import { useCallback, useId, useLayoutEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import logger from "../../../../../../Logger"
import DynamicForm from "../../../dynamic-form"
import { FIELD_GROUP_TYPES } from "../../../dynamic-form.constants"

function CustomEditComponent(props) {
  const { api, parentProps, rowIndex, fieldName, values, errors, id, shadowFormNodeId, hasFocus, onCellLayout } = props
  const fieldData = parentProps.fieldData.find((fd) => fd.name === fieldName)
  const shadowFormNode = document.getElementById(shadowFormNodeId)

  const [oldFieldValue, setOldFieldValue] = useState(values[parentProps.name][rowIndex][fieldName])

  // Setup "Sub Form" for this cell
  const cellFormData = {
    layout: "1-COLUMN",
    layout_data: [
      {
        id: "layout-1",
        layout_order: 10,
        layout_width: 12,
        groups: [
          {
            view_order: 10,
            id: `_cellEditForm_Group_${fieldName}`,
            type: FIELD_GROUP_TYPES.FIELDS,
            label: "",
            fields: [
              {
                id: `_cellEditForm_${fieldName}`,
                width: 12,
                rows: fieldData.rows,
                enabled: fieldData.enabled,
                type: fieldData.type,
                label: "",
                name: fieldName,
                placeholder: fieldData.placeholder,
                value: oldFieldValue,
                icon: null,
                options: fieldData.options,
                validations: fieldData.validations,
                comments: "",
              },
            ],
          },
        ],
      },
    ],
  }
  const [cellFormValid, setCellFormValid] = useState(true)
  const cellFormFieldsTargetId = useId()
  const [cellFormFieldsTarget, setCellFormFieldsTarget] = useState(null)
  const [formIsActive, setFormIsActive] = useState(false)
  const formFocused = useRef(false)

  const focusInputsIfNeeded = useCallback(() => {
    if (cellFormFieldsTarget && formFocused.current === false) {
      formFocused.current = true
      logger.info(`${fieldName}: focusing input field..`)
      // TODO: This should be internal to Dynamic Form
      let inputElement = cellFormFieldsTarget.querySelector("textarea")
      if (inputElement) {
        logger.info(`Found textarea to focus...`)
      } else {
        inputElement = cellFormFieldsTarget.querySelector("input")
      }
      if (inputElement) {
        logger.info(`Found input to focus...`)
      } else {
        inputElement = cellFormFieldsTarget.querySelector("select")
      }
      if (inputElement) {
        logger.info(`Found select to focus...`)
      }

      inputElement?.focus()
    } else {
      logger.info(`${fieldName}: fields not ready for focus!`)
    }
  }, [cellFormFieldsTarget])

  const cellFormOnUpdateHandler = useCallback(
    ({ values: cellFormValues }) => {
      if (values && parentProps.name && values[parentProps.name]) {
        const newValue = cellFormValues?.[fieldName]
        if (newValue != oldFieldValue) {
          setOldFieldValue(newValue)
          // Update DataGrid value
          api.setEditCellValue({
            id: id,
            field: fieldName,
            value: newValue,
          })
        }
        setFormIsActive(true) // trigger focus
      }
    },
    [rowIndex, api, fieldName, values, id, parentProps.name, oldFieldValue]
  )

  useLayoutEffect(() => {
    if (onCellLayout) {
      onCellLayout()
    }
  }, [onCellLayout])

  useLayoutEffect(() => {
    const theTarget = document.getElementById(cellFormFieldsTargetId)
    if (theTarget) {
      setCellFormFieldsTarget(theTarget)
    }
  }, [cellFormFieldsTargetId])

  useLayoutEffect(() => {
    if (hasFocus && formIsActive) {
      focusInputsIfNeeded()
    }
  }, [hasFocus, formIsActive])

  return (
    <div id={cellFormFieldsTargetId} className={`w-100`}>
      {cellFormFieldsTarget ? (
        createPortal(
          <DynamicForm
            key={`customEdit_form_${fieldName}`}
            formData={cellFormData}
            setFormValid={setCellFormValid}
            onUpdateCallback={cellFormOnUpdateHandler}
            formElementsTargetNode={cellFormFieldsTarget}
          />,
          shadowFormNode
        )
      ) : (
        <></>
      )}
    </div>
  )
}

export default CustomEditComponent
